import type { QSetSimilarityResultData, QSetSimilarityResultRowArray } from '../../types';
import { getQSetRunningNumber } from '../get-qset-running-number';

export default function generateSingleStatusData(
  data: QSetSimilarityResultData[],
  uniqueQSetCodes: string[],
): [string[], QSetSimilarityResultRowArray[]] {
  const columns = Array.from(uniqueQSetCodes).sort((a, b) => {
    const numA = parseInt(a.replace(/\D/g, ''), 10);
    const numB = parseInt(b.replace(/\D/g, ''), 10);
    return numA - numB;
  });

  const rows: QSetSimilarityResultRowArray[] = [];
  for (let i = 0; i < columns.length; i++) {
    // Convert QSet ID to running numbers
    rows.push([getQSetRunningNumber(columns[i])]);
    for (let j = 0; j < columns.length; j++) {
      if (i === j || j > i) {
        rows[i].push(null);
      } else {
        const found = data.find(
          ({ qSetACode, qSetBCode }) =>
            (qSetACode === columns[i] && qSetBCode === columns[j]) ||
            (qSetACode === columns[j] && qSetBCode === columns[i]),
        );
        rows[i].push(found?.duplicationRate ?? null);
      }
    }
  }
  return [columns.map(getQSetRunningNumber), rows];
}
